import { Form, Formik } from 'formik';
import React, { FC, ReactElement, useState } from 'react';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import { useFilter } from '../../../contexts/table/FilterContext';
import { useTable } from '../../../contexts/table/TableContext';
import WizardSideBarStep from '../../../models/WizardSideBarStep';
import { TableColumn } from '../../../models/table/TableColumn';
import Wizard from '../../wizard/wizard';
import BuildingEntity from './entity/building-entity';
import ControllerEntity from './entity/controller-entity';
import FloorEntity from './entity/floor-entity';
import ReaderEntity from './entity/reader-entity';
import ZoneEntity from './entity/zone-entity';
import Summary from './summary-step';

interface EntityFilterWizardProps {
    defaultContent: ReactElement[];
    defaultSteps: WizardSideBarStep[];
    onClose: () => void;
    filterModalTrigger: string;
    type: string;
    onReset: (event: any) => void;
}

const EntityFilterWizard: FC<EntityFilterWizardProps> = ({ defaultContent, defaultSteps, onClose, filterModalTrigger, type, onReset }) => {
    const { translate } = useLocale();
    const filterContext = useFilter();
    const tableContext = useTable();
    const [step, setStep] = useState<number>(1);
    const steps: WizardSideBarStep[] = [
        ...defaultSteps,
        {
            title: translate.byKey(TranslationKeys.selectAFilterType),
            description: "",
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: "",
            substeps: []
        }
    ]

    const onNext = (event: any) => {
        setStep(step + 1);
    }

    const onBack = (event: any) => {
        onReset(event);
        setStep(step - 1);
    }

    const content: ReactElement[] = [
        ...defaultContent,
        type === "controller" ?
            <ControllerEntity
                key={"wizard-1"}
                onBack={onBack}
                onNext={onNext}
                filterModalTrigger={filterModalTrigger} /> :
            type === "zone" ?
                <ZoneEntity
                    key={"wizard-1"}
                    onBack={onBack}
                    onNext={onNext}
                    filterModalTrigger={filterModalTrigger} /> :
                type === "reader" ?
                    <ReaderEntity
                        key={"wizard-1"}
                        onBack={onBack}
                        onNext={onNext}
                        filterModalTrigger={filterModalTrigger} /> :
                    type === "building" ?
                        <BuildingEntity
                            key={"wizard-1"}
                            onBack={onBack}
                            onNext={onNext}
                            filterModalTrigger={filterModalTrigger} /> :
                        type === "floor" ?
                            <FloorEntity
                                key={"wizard-1"}
                                onBack={onBack}
                                onNext={onNext}
                                filterModalTrigger={filterModalTrigger} /> :
                            <></>,
        <Summary
            onBack={onBack}
            type={type} />
    ];

    const handleSubmit = async (values: any) => {
        const column: TableColumn | undefined = tableContext.tableDescriptor.find(column => column.accessor === type);

        if (column) {
            for (const item of values.filterNames) {
                const columnKey = column.lookupName ?? ''
                await filterContext.updateFilters(columnKey, item.value, item.label, columnKey);
            }
        }
        onClose();
    }

    return <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={handleSubmit}>
        <Form>
            <Wizard name={translate.byKey(TranslationKeys.dataFilters)}
                step={step}
                onClose={onClose}
                sidebarSteps={steps}>
                {content}
            </Wizard>
        </Form>
    </Formik>
}

export default EntityFilterWizard;